<template>
  <div class="relative grid gap-0 px-5 pb-2 overflow-hidden">
    <Post :data="data" />
  </div>
</template>

<script>
import Post from "./Post";

export default {
  components: {
    Post,
  },
  props: {
    data: Object,
  },
};
</script>

<style>
.lock {
  filter: blur(12px);
  pointer-events: none;
}
</style>
